<template>
  <div class="body-wrapper">
    <Header :title="'Reports: ' + username" />
    <div class="body-container" v-if="selectedUser.first_name">
      <div class="user-box">
        <div class="header">
          <img
            v-if="getUserPicture() !== ''"
            :src="getUserPicture()"
            class="user-profile"
          />
          <div v-else class="blank-image"></div>
          <img class="icon" src="../assets/profile_verified.png" v-if="selectedUser.verified">
          <img class="icon" src="../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
          <div class="user-details">
            <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
            <p>{{ selectedUser.email }}</p>
            <p>{{ age }} - {{ selectedUser.gender }}</p>
            <p>{{ selectedUser.location }}</p>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>BIO</label>
            <span>{{selectedUser.bio}}</span>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>LAST ACTIVE</label>
            <span>{{ formatDate(selectedUser.updated_at) }}</span>
          </div>
          <div class="modal-input">
            <label>REPORTED TIMES</label>
            <span>{{selectedUser.total_count}}</span>
          </div>
        </div>
        <div class="modal-row">
          <div class="modal-input">
            <label>ACCOUNT CREATED</label>
            <span>{{ formatDate(selectedUser.created_at) }}</span>
          </div>
          <div class="modal-input">
            <label>VERIFIED SINCE</label>
            <span>{{ formatDate(selectedUser.updated_at) }}</span>
          </div>
        </div>
      </div>
      <DataTable 
        url="/v1/manage_reports"
        :fields="fields"     
        :extraParams="{ user: selectedUser.id }"     
        @details-clicked="detailsClicked" />
    </div>

    <ReportDetailModal
      v-if="viewReportDetails"/>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import DataTable from '../components/table/DataTable.vue';
import { getUserReportDetails } from '@/api/requests';
import { formatDateTime } from '@/utils'
import ReportDetailModal from '../components/modals/ReportDetailModal.vue';

export default {
  name: 'UserReports',

  components: {
    Header,
    DataTable,
    ReportDetailModal
  },

  mounted() {
    const userId = this.$route.params.userId;
    getUserReportDetails(userId).then(response => {
      this.$store.dispatch('reports/selectUser', response.data);
    }).catch(() => {
    
    });
  },

  methods: {
    loadFeedback() {
      getFeedback().then(response => {
        this.feedback.push(...response.data);
      }).catch(() => {
        // TODO errors
      });
    },

    detailsClicked(value) {
      if (value['type'] === 'user') {
        this.$router.push({ name: 'UserReports', params: { userId: value.data.user.id } })
      } else {
        this.$store.dispatch('reports/reportClicked', value.data);
      }
    },

    getUserPicture() {
      if (this.selectedUser.image !== "" && this.selectedUser.image !== null) {
        if (this.selectedUser.image.indexOf('blob:') > -1) {
          return this.selectedUser.image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + this.selectedUser.image;
      }
      return "";
    },

    formatDate(date) {
      return formatDateTime(date);
    },
  },

  computed: {
    fields() {
      return [
        {
          name: 'report-id-slot',
          title: 'Report ID',
        },
        {
          name: 'report-count-slot',
          title: 'Count',
          sortField: 'total_count'
        },
        {
          name: "report-user-static-slot",
          title: 'User',
          width: '15%'
        },
        {
          name: 'report-reasons-slot',
          title: 'Report Type',
        },
        {
          name: 'item_type',
          title: 'Category',
        },
        {
          name: 'created_at',
          title: 'Date',
          sortField: 'created_at',
          formatter: formatDateTime
        },
        {
          name: 'resolution',
          title: 'Outcome',
          sortField: 'resolution',
        },
      ]
    },

    apiUrl() {
      return apiUrl();
    },

    username() {
      return this.$store.state.reports.selectedUser?.first_name || '...';
    },

    selectedUser() {
      return this.$store.state.reports.selectedUser;
    },

    age() { 
      let diff_ms = Date.now() - Date.parse(this.selectedUser.birthday);
      let age_dt = new Date(diff_ms); 
    
      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },

    viewReportDetails: {
      get () {
        return this.$store.state.reports.viewReportDetails
      },
      set (value) {
        this.$store.commit('users/updateAttribute', {value: value, type: 'viewReportDetails'})
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.body-container {
  height: calc(100% - 60px);

  .container {
    height: calc(100% - 60px);
    border: 1px solid $sec6;
    margin-bottom: $spacing-base;
  }
  .container-header {
    padding: $spacing-base;
    background: $sec7;
    border-bottom: 1px solid $sec6;
    display: flex;
    flex-direction: row;

    h3 {
      padding: 0;
      margin: 0;
      flex: 1;
      font-weight: normal;
      font-size: 1em;
      color: $sec2;
      line-height: 25px;
    }

    .report-actions {
      button {
        margin-left: $spacing-small;
      }
    }
  }
  .container-body {
    height: calc(100% - 44px);
    overflow-y: scroll;
  }
  
  .user-box {
    background: $sec0;
    width: 50%;
    max-width: 500px;
    padding: $spacing-base;
    margin: $spacing_base;

    .header {
      display: flex;
      align-items: center;
      padding-bottom: $spacing-base;

      .user-details {
        flex: 1;
        margin-left: $spacing-base;
        display: flex;
        flex-direction: column;

        h3 {
          color: #FFF;
          padding: 0;
          margin: 0;
          font-size: $font-size-medium;
          display: inline-block;
        }

        p {
          margin: 0;
          padding: 0;
          font-size: $font-size-small;
          color: $sec5;
          font-weight: bold;
          text-transform: uppercase;
        }
      }

      .blank-image {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        background: $sec7;
      }

      .user-profile {
        display: inline-block;
        border-radius: 80px;
        width: 80px;
        height: 80px;
      }
      .icon {
        margin-left: -14px;
        margin-top: -50px;
      }
      i {
        color: $sec4;
        cursor: pointer;
      }
    }

    .modal-row {
      display: flex;
      margin-bottom: $spacing-base;
      gap: $spacing-small;
      label {
        display: block;
        color: $sec6;
        font-size: $font-size-x-small;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 2px;
      }

      span {
        color: $sec4;
        font-size: $font-size-small;
      }

      .modal-input {
        flex: 1;
      }
    }
  }
}
</style>
